"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuColumn = exports.Columns = exports.Logo = exports.AppTagline = exports.AppName = exports.Header = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var layout_1 = __importDefault(require("antd/es/layout"));
var VarnishContext_1 = require("../VarnishContext");
var Layout_1 = require("../Layout");
var AI2Banner_1 = require("./AI2Banner");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollY = 0;
        _this.onScroll = function () {
            // This implements logic that:
            //  1. If the user scrolls down the page, at all, the AI2 banner at the top is hidden.
            //  2. If the user scrolls up, at all, the AI2 banner becomes visible again.
            if (_this.banner.current !== null) {
                var distance = window.scrollY - _this.lastScrollY;
                _this.lastScrollY = window.scrollY;
                var isCollapsed = distance > 0;
                _this.setState({ isCollapsed: isCollapsed });
            }
        };
        _this.state = {
            isCollapsed: false,
            currentHeaderHeight: 0,
        };
        _this.container = React.createRef();
        _this.banner = React.createRef();
        return _this;
    }
    Header.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.onScroll);
        if (this.container.current !== null) {
            var currentHeaderHeight = this.container.current.getBoundingClientRect().height;
            this.setState({ currentHeaderHeight: currentHeaderHeight });
        }
    };
    Header.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.onScroll);
    };
    Header.prototype.componentDidUpdate = function () {
        var offset = this.getTopOffset();
        this.context.setHeaderHeight(this.state.currentHeaderHeight + offset);
    };
    Header.prototype.getTopOffset = function () {
        if (!this.props.alwaysVisible && this.state.isCollapsed && this.banner.current !== null) {
            return (-1 *
                (this.banner.current.getBoundingClientRect().height -
                    parseFloat(window.getComputedStyle(this.banner.current).paddingBottom || '0')));
        }
        return 0;
    };
    Header.prototype.render = function () {
        return (React.createElement(Sticky, { ref: this.container, style: { top: this.getTopOffset() + "px" } },
            React.createElement(layout_1.default.Header, null,
                React.createElement(AI2Banner_1.AI2Banner, { ref: this.banner }),
                React.createElement(HeaderContent, null, this.props.children))));
    };
    Header.contextType = VarnishContext_1.VarnishContext;
    return Header;
}(React.PureComponent));
exports.Header = Header;
var HeaderContent = styled_components_1.default(Layout_1.Content)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n"], ["\n    display: flex;\n    align-items: center;\n    padding-top: 0;\n    padding-bottom: 0;\n"])));
var Sticky = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    && {\n        position: sticky;\n        top: 0;\n        z-index: ", ";\n        width: 100%;\n        box-shadow: ", ";\n        transition: top 200ms ease-in-out;\n    }\n\n    .ant-layout-header {\n        height: initial;\n        padding: 0;\n        background: ", ";\n        line-height: initial;\n    }\n"], ["\n    && {\n        position: sticky;\n        top: 0;\n        z-index: ", ";\n        width: 100%;\n        box-shadow: ", ";\n        transition: top 200ms ease-in-out;\n    }\n\n    .ant-layout-header {\n        height: initial;\n        padding: 0;\n        background: ", ";\n        line-height: initial;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.zIndex.header;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.header;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.common.white;
});
exports.AppName = styled_components_1.default.h5(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    font-size: 1.9rem;\n    line-height: 1.65rem;\n    text-transform: none;\n    display: inline-block;\n\n    @media (max-width: ", ") {\n        font-size: 1.75rem;\n        line-height: 1.5rem;\n    }\n"], ["\n    margin: 0;\n    padding: 0;\n    font-size: 1.9rem;\n    line-height: 1.65rem;\n    text-transform: none;\n    display: inline-block;\n\n    @media (max-width: ", ") {\n        font-size: 1.75rem;\n        line-height: 1.5rem;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xs;
});
exports.AppTagline = styled_components_1.default.h6(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    padding: 0;\n    font-size: 1.5rem;\n    line-height: 1.65rem;\n    text-transform: none;\n    display: inline-block;\n\n    @media (max-width: ", ") {\n        font-size: 1.375rem;\n        line-height: 1.5rem;\n    }\n"], ["\n    margin: 0;\n    padding: 0;\n    font-size: 1.5rem;\n    line-height: 1.65rem;\n    text-transform: none;\n    display: inline-block;\n\n    @media (max-width: ", ") {\n        font-size: 1.375rem;\n        line-height: 1.5rem;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.breakpoints.xs;
});
var LogoGrid = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    align-items: center;\n    gap: ", ";\n\n    &:hover ", " {\n        text-decoration: none;\n        display: inline-block;\n    }\n"], ["\n    display: grid;\n    grid-template-columns: repeat(4, auto);\n    align-items: center;\n    gap: ", ";\n\n    &:hover ", " {\n        text-decoration: none;\n        display: inline-block;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs;
}, exports.AppName);
var ConditionalAnchorWrapper = function (props) {
    return props.href ? (React.createElement(DecorationlessAnchor, { href: props.href, target: "_blank", rel: "noopener noreferrer" }, props.children)) : (props.children);
};
var DecorationlessAnchor = styled_components_1.default.a(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    &&:hover {\n        text-decoration: none;\n    }\n"], ["\n    &&:hover {\n        text-decoration: none;\n    }\n"])));
var Logo = function (props) {
    return (React.createElement(ConditionalAnchorWrapper, { href: props.href },
        React.createElement(LogoGrid, null,
            props.children,
            props.label,
            props.label && props.tagline ? (props.separator ? (props.separator) : (React.createElement(exports.AppTagline, null, "\u2014"))) : null,
            props.tagline)));
};
exports.Logo = Logo;
exports.Columns = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    width: 100%;\n    align-items: center;\n    padding: ", " 0;\n"], ["\n    display: grid;\n    grid-template-columns: ", ";\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    width: 100%;\n    align-items: center;\n    padding: ", " 0;\n"])), function (_a) {
    var columns = _a.columns;
    return columns;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.md;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm;
});
exports.MenuColumn = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    &&&& {\n        justify-self: right;\n        line-height: 77px;\n        a:hover {\n            text-decoration: none;\n        }\n        ul {\n            margin: -", " 0;\n        }\n    }\n"], ["\n    &&&& {\n        justify-self: right;\n        line-height: 77px;\n        a:hover {\n            text-decoration: none;\n        }\n        ul {\n            margin: -", " 0;\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=Header.js.map